import { apiRoutes } from '@/config/api-routes'
import { companiesApi } from '@/lib/axios'

import {
  FailureFeatures,
  transformFailures,
} from './get-planting-failure-summary-from-diagnosis'

export async function createPlantingFailure(culture: string, demandId: string) {
  const { data } = await companiesApi.post<FailureFeatures[]>(
    apiRoutes.createPlantingFailure(culture, demandId),
  )

  return transformFailures(data)
}
